export interface User {
  id: string;
  name: string;
  email: string;
  phone: string;
  createdAt: string;
}

export const AUTH_KEY = 'descuentos_luz_user';

export const saveUser = (user: User): void => {
  localStorage.setItem(AUTH_KEY, JSON.stringify(user));
};

export const getUser = (): User | null => {
  const data = localStorage.getItem(AUTH_KEY);
  return data ? JSON.parse(data) : null;
};

export const isAuthenticated = (): boolean => {
  return getUser() !== null;
};

export const logout = (): void => {
  localStorage.removeItem(AUTH_KEY);
};

export const login = (email: string, password: string): User | null => {
  // Mock login
  const mockUser: User = {
    id: '1',
    name: 'Usuario Demo',
    email,
    phone: '600000000',
    createdAt: new Date().toISOString()
  };
  saveUser(mockUser);
  return mockUser;
};

export const register = (name: string, email: string, phone: string, password: string): User => {
  const newUser: User = {
    id: Date.now().toString(),
    name,
    email,
    phone,
    createdAt: new Date().toISOString()
  };
  saveUser(newUser);
  return newUser;
};
